import { atom } from "recoil";

export const currentConfiguration = atom({
    key: "configuration",
    default: {} 
});